
let scrollValue = 1;
let activeP2 = false;
let initFini = false;
let titre = document.getElementById("page2Titre");
let _scroll = document.getElementById("page2Scroll");

window.addEventListener('wheel', onWheel);

document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && activeP2) {  // Vérifie si la touche appuyée est 'Escape'
        //activeP2 = false
    }
});
  

let lastScrollTime = 0; // Stocke le dernier timestamp d'exécution

function onWheel(event) {
    const now = Date.now(); // Récupère le temps actuel en millisecondes

    if (now - lastScrollTime < 700) {
        return;
    }

    lastScrollTime = now; // Met à jour le dernier temps d'exécution

    if (activeP2 && initFini) {
        const direction = Math.sign(event.deltaY); // -1 pour haut, 1 pour bas
        scrollValue += direction;
        if (scrollValue < 1) {
            scrollValue = 8;
        }
        if (scrollValue > 8) {
            scrollValue = 1;
        }
        Scroll2(direction);

        window.animateJumpingLetters("page2Titre", 50, 200, 20, direction < 0);
        
    }
}

/*
const images = document.querySelectorAll('.illustration_image');
let prevPosX = 0;
let PosX = 0;
let prevPosY = 0;
let PosY = 0;
images.forEach(image => {
    let isHovered = false;

    image.addEventListener('mouseenter', () => {
        isHovered = true;
        image.classList.add('hovered');
    });

    image.addEventListener('mouseleave', () => {
        isHovered = false;
        image.classList.remove('hovered');
    });

    image.addEventListener('mousemove', (e) => {
        if (isHovered) {

            const boundingBox = image.getBoundingClientRect();
            const offsetX = e.clientX - boundingBox.left;
            const offsetY = e.clientY - boundingBox.top;

            PosX = (((offsetX / boundingBox.width - 0.5) * 10) + prevPosX*29)/30;
            PosY = (((offsetY / boundingBox.height - 0.5) * 10) + prevPosY*29)/30;
            prevPosX = PosX; 
            prevPosY = PosY;

            image.style.transform = `translate(${PosX}px, ${PosY}px)`;

        }
    });
});*/


/* <div id="illu1Container">
    <p id="illu1Text"> voila le texte de l'illu 1 </p>
    <div id="illu1ImageContainer">
        <img id="illu1" onclick="FullIllu()" src="src/png/illustrations/1.png" alt="illustration 1"> 
    </div>
</div> */

function FullIllu(){

}

function Scroll2(direction){
    let passe = scrollValue-direction;
    if (passe<1) {
        passe = 8;
      }
      if (passe>8) {
        passe = 1;
      }

    //let prevIlluContainer = document.getElementById("illu"+ passe +"Container");
    let prevIlluText = document.getElementById("illu"+ passe +"Text");
    let prevIlluImageContainer = document.getElementById("illu"+ passe +"ImageContainer");
    let prevIlluImage = document.getElementById("illu"+ passe);
    let illuContainer = document.getElementById("illu"+ scrollValue +"Container");
    let illuText = document.getElementById("illu"+ scrollValue +"Text");
    let illuImageContainer = document.getElementById("illu"+ scrollValue +"ImageContainer");
    let illuImage = document.getElementById("illu"+ scrollValue);
    //prevIlluContainer.style.zIndex = 70;
    //illuContainer.style.zIndex = 80;

    illuImage.style.pointerEvents = "all";
    prevIlluImage.style.pointerEvents = "none";
    
        console.log(passe + " vers " + scrollValue)
        //let actualopacity = window.getComputedStyle(prevIlluContainer).opacity;
        const actualx = gsap.getProperty(prevIlluImageContainer, "x");
        console.log(actualx);
        /*
        gsap.to(prevIlluContainer, {
            opacity: 0,  // Valeur d'arrivée (l'élément disparaît)
            duration: 1,  // Durée de l'animation
            ease: "power2.inOut"  // Courbe d'accélération
        });*/
        gsap.to(prevIlluImageContainer, {
            y: 15*direction +"vw",
            height: "0vw",
            duration: 1,  // Durée de l'animation
            ease: "power2.inOut",  // Courbe d'accélération
            opacity: 0,
        });
        /*
        gsap.to(illuContainer, {
            opacity: 1,  // Valeur d'arrivée (l'élément disparaît)
            duration: 1,  // Durée de l'animation
            ease: "power2.inOut"  // Courbe d'accélération
        });*/
        gsap.fromTo(illuImageContainer, {
            y: -15*direction+"vw",
            height: 0,
            opacity: 0,  // Valeur de départ (l'élément est visible)
        },{
            y: 0 ,
            opacity: 1,
            height: "30vw",
            duration: 1,  // Durée de l'animation
            ease: "power2.inOut"  // Courbe d'accélération
        });

    //window.animateText("illu"+ scrollValue +"Text",30,50,false,1,true)
}

let illuContainer = document.getElementById("illuContainer");
let illuText = document.getElementById("illuText");
let illu1ImageContainer = document.getElementById("illu1ImageContainer");
let illu1Image = document.getElementById("illu1");
function illu1() {
    setTimeout(() => {
        
        gsap.fromTo(illuContainer, {
            opacity: 0,  // Valeur de départ (l'élément est visible)
        }, {
            opacity: 1,  // Valeur d'arrivée (l'élément disparaît)
            duration: 2,  // Durée de l'animation
            ease: "power2.Out"  // Courbe d'accélération
        });
        gsap.fromTo("#illu1ImageContainer", 
            {
                height: "30vw",
                x: "30vw",  // Valeur de départ
                y: "0px"
            }, 
            {
                height: "30vw",
                x: "0px",  // Valeur de fin
                y: "0px",
                duration: 2,
                ease: "power2.out",  // Courbe d'accélération
                overwrite: "auto"
            });
          
    }, 500);  // Délai
    setTimeout(() => {
        initFini = true;
    }, 1000);  // Délai
    window.animateText("illuText",30,1000,false,1,true)
}

    illuContainer.style.opacity = 0;
    illuContainer.style.zIndex = 8;

titre.style.opacity = 0;
_scroll.style.opacity = 0;

///id, delay, offset, scint
function page2Start() {
    document.getElementById("page2").style.display = "flex";

    illuContainer.style.opacity = 0;
    illuContainer.style.zIndex = 8;
    gsap.set([
        "#illu2ImageContainer", 
        "#illu3ImageContainer", 
        "#illu4ImageContainer", 
        "#illu5ImageContainer", 
        "#illu6ImageContainer", 
        "#illu7ImageContainer", 
        "#illu8ImageContainer"
        ],{
            y: "30vw",
            opacity: 0
        }
    );

    gsap.set([
        "#illu1ImageContainer"
        ],{
            y: 0,
            opacity: 1
        }
    );
      

    initFini = false
    scrollValue = 1;
    window.animateText("page2Titre",90,200,false)
    window.animateText("page2Scroll",90,2000,true)
    illu1()
    setTimeout(() => {
        window.animateJumpingLetters("page2Titre",5,2,0);
    }, 2000);  // Délai
    activeP2 = true;
    gsap.to("#page2", {
        opacity: 1,  // Valeur d'arrivée (l'élément disparaît)
        duration: 1,  // Durée de l'animation
        ease: "power2.inOut"  // Courbe d'accélération
    });
    gsap.to("#page2Bg", {
        opacity: 0.5,  // Valeur d'arrivée (l'élément disparaît)
        duration: 2,  // Durée de l'animation
        ease: "power2.inOut"  // Courbe d'accélération
        });
}

function page2End() {
    document.getElementById("page2").style.display = "none";
    activeP2 = false;
    gsap.to("#page2", {
        opacity: 0,  // Valeur d'arrivée (l'élément disparaît)
        duration: 1.5,  // Durée de l'animation
        ease: "power2.Out"  // Courbe d'accélération
    });

}

document.getElementById("page2").style.display = "none";
// Attacher la fonction à `window`
window.page2Start = page2Start;
window.page2End = page2End;